//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonImg from '@/components/views/common_img'
import { enable_webp, handleBuidingMiniBanner } from '@/common/utils/map_view_data'
import { sendCtmEvtLog } from '@/utils/log'
import PositionLog, { clickHouseLog } from '@/data/position_log'
import BuildingCompare from '@/data/building_compare'

const handleMiniImg = (swiper_list, type) => {
    if (swiper_list && swiper_list.length ) {
        swiper_list.some((item) => {
            if (item.type === type) {
                item.mini_url = handleBuidingMiniBanner(item.url)
                return true
            }
        })
    }
}
export default {
    data () {
        return {
            current_count: 0,
            selected_tab: 'pic',
            selected_index: 0,
            tabs: [],
            swiper_list: [],
            min_loaded: false,
            loaded: false,
            webp: enable_webp,
        }
    },
    computed: {
        pic_order () {
            return this.current_count + 1 - (this.swiper_list?.length - this.banners?.length)
        },
        pic_banner_len () {
            return this.swiper_list.filter(({ type }) => type === 'pic').length
        },
    },
    mounted () {
        this.$watch(function () {
            return {
                recommendation: this.recommendation,
                focus_swipers: this.house.focus_swipers || [],
                banners: this.banners || [],
            }
        }, function ({ banners, focus_swipers, recommendation }) {
            const tabs = []
            const swiper_list = []
            const url_types = {
                'vr_panorama': this.cover_720,
                'planar_graph': this.planar_graph_url,
                'vr': this.vr_url,
                'apartment_sunlight': this.sunlight_url,
                'video': this.video_url
            }
            if (focus_swipers && focus_swipers.length) {
                this.selected_tab = focus_swipers[0].category
                focus_swipers.forEach(item => {
                    tabs.push({
                        type: item.category,
                        name: item.name
                    })
                    swiper_list.push({
                        url: url_types[item.category],
                        type: item.category
                    })
                })
            }
            if (banners && banners.length) {
                tabs.push({
                    type: 'pic',
                    name: '图片'
                })
            }
            const recommendation_list = recommendation?.map((item, i) => {
                return {
                    url: item.photo_url,
                    is_recommdataion: true,
                    open_type: item.open_type,
                    position: item.position,
                    href: item.href,
                    pos_id: item.id,
                    pos_index: i,
                    type: 'pic'
                }
            })
            const pic_list = banners?.map((url) => ({
                url,
                type: 'pic'
            }))
            pic_list?.unshift(...recommendation_list)
            swiper_list.push(...pic_list)
            if (swiper_list.length) {
                if (this.head_photo_url) {
                    swiper_list[0].url = this.head_photo_url
                }
                swiper_list[0].mini_url = handleBuidingMiniBanner(swiper_list[0].url)
            }
            this.tabs = tabs
            this.swiper_list = swiper_list.length ? swiper_list.map((item) => {
                return {
                    ...item,
                    url: item.url || ( banners && banners.length && banners[0] ? banners[0].photo_url : this.default_img)
                }
            }) : []
        }, { immediate: true })
    },
    watch: {
        selected_tab (latest, old) {
            if (latest && old) {
                this.swiper_list.some(({ type }, i) => {
                    if (type === latest) {
                        this.current_count = i
                        this.$refs.swiper.$swiper.slideTo(i)
                        return true
                    }
                })
            }
        }
    },
    methods: {
        loadMinImg () {
            this.min_loaded = true
        },
        loadImg () {
            this.loaded = true
        },
        changeSelectTab (tab, i) {
            this.selected_tab = tab
            this.selected_index = i
        },
        tabShare () {
            sendCtmEvtLog('楼盘详情页-顶部分享按钮点击')
            this.$emit('showShareOption')
        },
        changeSwiper (e) {
            this.current_count = e.activeIndex
            const { type, is_recommdataion, pos_id, position, pos_index } = this.swiper_list[this.current_count]
            this.swiper_list.some((item, i) => {
                if (type === item.type) {
                    this.selected_index = i
                    return true
                }
            })
            this.selected_tab = type
            if (is_recommdataion) {
                PositionLog.log(position, {
                    id: pos_id,
                    pos: pos_index,
                    pos_name: position
                })
            }
        },
        tapLog(name){
            this.$sendCtmEvtLog(`楼盘详情顶部大图-${name}点击`,{building_id: this.building_id})
        },
        tapSwiper (i) {
            const { type, url, is_recommdataion, href, pos_id, position, pos_index, open_type, id } = this.swiper_list[i]
            if (type === 'planar_graph') {
                this.$emit('goPlanarGraph')
                this.tapLog('总平')
                return
            }
            if (type === 'vr_panorama') {
                this.$emit('openWeb720')
                this.tapLog('航拍')
                return
            }
            if (type === 'vr') {
                this.$emit('goVR')
                this.tapLog('VR')
                return
            }
            if (type === 'video') {
                this.$emit('goVideo')
                this.tapLog('视频')
                return
            }
            if(type === 'apartment_sunlight'){
                this.$emit('goSunlight')
                this.tapLog('日照')
                return
            }
            if (is_recommdataion) {
                clickHouseLog(pos_id, {
                    pos: pos_index,
                    pos_name: position
                })
                if (href) {
                    wx[open_type]({
                        url: href
                    })
                    return
                }
            }
            this.tapLog('图片')
            this.$wx.previewImage({
                current: url,
                urls: this.banners
            })
        }
    },
    components: {
        CommonImg
    },
    props: {
        house: Object,
        loading: Boolean,
        vr_url: String,
        show_vr: Boolean,
        banners: Array,
        view_count: [ Number, String ],
        video_url: String,
        show_720: Boolean,
        cover_720: String,
        show_video: Boolean,
        open_type: String,
        recommendation: Array,
        building_id: [Number, String],
        planar_graph_url: String,

    }
}
